import { faBell, faHeart } from "@fortawesome/duotone-light-svg-icons"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import { useMemo } from "react"

import useClientListTabStore, {
  ClientListTab,
} from "./hooks/useClientListTabStore"
import { useClientsWithTodos } from "./hooks/useClientsWithTodos"
import TabItem from "../../components/tabItem/TabItem"

const ClientListTabs = () => {
  const { tab, setTab } = useClientListTabStore()
  const clientsWithTodos = useClientsWithTodos()

  const numTodos = useMemo(() => {
    return clientsWithTodos.flatMap((client) => client.todos).length
  }, [clientsWithTodos])

  return (
    <div className="flex flex-row gap-2 border-b border-borderPrimary w-full pt-2 px-3">
      <TabItem
        size="small"
        label="Clients"
        onClick={() => setTab(ClientListTab.CLIENTS)}
        icon={faHeart}
        isSelected={tab === ClientListTab.CLIENTS}
      />
      <TabItem
        label={
          (
            <div className="flex flex-row gap-1 items-center">
              <Typography variant="bodySmall">To-do</Typography>
              {numTodos > 0 && (
                <div className="w-4 h-4 flex items-center justify-center bg-primary rounded-full">
                  <Typography
                    variant="bodyXSmallBold"
                    color={JoonUIColor.text.inverted}
                  >
                    {numTodos}
                  </Typography>
                </div>
              )}
            </div>
          ) as any
        }
        onClick={() => setTab(ClientListTab.TODOS)}
        icon={faBell}
        isSelected={tab === ClientListTab.TODOS}
        size="small"
      />
    </div>
  )
}

export default ClientListTabs
